import { http } from "./http.js";

export const post = (url, options) => http.post(url, options);
